import React from 'react';
import { object } from 'prop-types';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import EmbeddedPDF from './EmbeddedPDF';
import cssVariables from '../../../../css/css-variables';
import { useGetInvoicePDF } from '../../queries/hooks/invoiceHooks';
import { fetchInvoicePdfError, setGlobalError } from '../../actions/AppActions';
import { logout } from '../App';

const InvoicePdfPage = ({ location }) => {
  const dispatch = useDispatch();

  const { routeToken, invoiceId } = useParams();
  const { data: invoicePdf } = useGetInvoicePDF(routeToken, invoiceId, {
    onError: (error) => {
      if (error?.response?.status === 403) {
        dispatch(
          setGlobalError({
            title: 'Access is required to view this invoice',
            description: (
              <>
                You cannot view this invoice due to invalid access. <br />
                You can also go back to <a href="/account-home">My Account</a> or{' '}
                <button
                  type="button"
                  style={{
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    color: `${cssVariables.colors.Primary}`,
                  }}
                  onClick={logout(dispatch)}
                >
                  Sign Out
                </button>
                .
              </>
            ),
          })
        );
      } else {
        dispatch(fetchInvoicePdfError(error));
      }
    },
  });

  return <EmbeddedPDF pdf={invoicePdf?.pdf} location={location} />;
};

InvoicePdfPage.propTypes = {
  location: object,
};

export default InvoicePdfPage;
